import clienteAxios from "../config/axios";

export async function addTransactionDocument(formData) {
  return clienteAxios.post(`/transactionDocument`, formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function addFiles(formData) {
  console.log(formData);
  return clienteAxios.post("/transactionDocument/file", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function updateTDoc(formData) {
  return clienteAxios.put("/transactionDocument",  formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function updateAditionalDocs(formData){
  return clienteAxios.post("/transactionDocument/aditionalDocs",  formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function deleteTransactionDocument(transactionDocument) {
  return clienteAxios.delete(`/transactionDocument`, { data: { transactionDocument } });
}

export async function deleteFile(fileName) {
  return clienteAxios.delete(`/transactionDocument/file/${fileName}`);
}

export async function getTDocByCodNroFor(tDocCodFor, tDocNroFor) {
  return clienteAxios.get(`/getTDocByCodNroFor/${tDocCodFor}/${tDocNroFor}`);
}

export async function createPDFReq(tDocCodFor ,tDocNroFor, userId) {
  return clienteAxios.post("/transactionDocument/informe", { tDocCodFor, tDocNroFor, userId });
}

export async function getFile(fileName) {
  return clienteAxios.get(`/transactionDocument/file/${fileName}`);
}

export async function downloadFile(fileName) {
  return clienteAxios.get(`/transactionDocument/file/download/${fileName}`, {
    responseType: 'blob', // clave para que response.data sea un Blob
  });
}

export async function getFiles(tDocCodFor, tDocNroFor) {
  return clienteAxios.get(`/transactionDocument/files/${tDocCodFor}/${tDocNroFor}`);
}

export async function sentToWebService(id, user){
  return clienteAxios.post("/transactionDocument/sendToWebService", { id, user });
}

export async function getTDocsByFiltrosRango(filtros){
  return clienteAxios.get(`/transactionDocument/filtrosRango/${filtros}`);
}

export async function getTDocsByFiltrosRangoAndCuit(cuit, filtros){
  return clienteAxios.get(`/transactionDocument/cuit/${cuit}/filtrosRango/${filtros}`);
}

export async function getTDocsByCodForAndCodOriAndNroCta(tDocCodFor, codOri, nroCta){
  return clienteAxios.get(`/getTDocsByCodForAndCodOriAndNroCta/tDocCodFor/${tDocCodFor}/codOri/${codOri}/nroCta/${nroCta}`);
}

export async function getTry(userId, filtros){
  return clienteAxios.get(`/transactionDocument/${userId}`);
}

export async function processInvoiceWithDocumentAI(file) {
  const formData = new FormData();
  formData.append("file", file);
  return clienteAxios.post("/documentAI/processInvoice", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
}
